import { CSSObject } from '@emotion/react';
import { createTheme } from '@mui/material/styles';

import AppColors, { grayColors, secondaryColors } from '~components/theme/styles/colors';

import MuiAccordion, { MuiAccordionDetails, MuiAccordionSummary } from './accordion';
import { xs, sm, md, lg, xl } from './breakpoints';
import MuiButton from './button';
import MuiDivider from './divider';
import MuiMenuItem from './menuItem';
import MuiSelect from './select';
import MuiSlider from './slider';
import StylesInput from './styles/inputs';
import MuiTextField from './textField';
import { body2, MuiTypography, typography } from './typography';

const theme = createTheme({
  breakpoints: {
    values: {
      xs,
      sm,
      md,
      lg,
      xl,
    },
  },

  typography,

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        div: {
          fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        },
      },
    },
    MuiDivider,

    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: AppColors.neutralGrey[5],
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': StylesInput.customInputDisabled as CSSObject,
        },
        input: StylesInput.customInput as CSSObject,
      },
    },

    MuiButtonGroup: {
      styleOverrides: {
        root: {
          border: '1px solid #bdbdbd',
          '& :not(:first-of-type)': {
            borderLeft: '1px solid #bdbdbd',
          },
        },
      },
    },

    MuiAccordion,
    MuiAccordionSummary,
    MuiAccordionDetails,
    MuiButton,
    MuiSlider,
    MuiTextField,
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
        },
      },
    },

    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: secondaryColors[200],
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiMenuItem,
    MuiSelect,
    MuiTypography,
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          padding: '8px 16px',
          background: grayColors[900],
          ...body2,
        },
        popper: {
          maxWidth: 600,
        },
      },
    },
  },

  palette: {
    action: {
      disabled: AppColors.neutralGrey[5],
      disabledBackground: AppColors.neutralGrey[6],
    },

    primary: {
      main: '#091325',
      light: '#303553',
      contrastText: '#fff',
    },

    secondary: {
      main: '#da7381',
      light: '#fdd4c3',
      contrastText: '#fff',
    },

    background: {
      default: '#262626',
      paper: '#262626',
    },

    divider: 'rgba(255,255,255,0.46)',
  },
});

export default theme;
